import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';
@Injectable()
export class LoaderService {
    private _isLoading = new BehaviorSubject<boolean>(false);
    isLoading = this._isLoading.asObservable().pipe(delay(0));
    show() {
        this._isLoading.next(true);
    }
    hide() {
        this._isLoading.next(false);
    }
  }
